var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#5FC9E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1828 26.3731L50.313 10.6782C48.7652 9.77393 46.232 9.77393 44.6842 10.6782L17.8144 26.3731C16.2664 27.2772 15 29.4966 15 31.305V62.695C15.1204 64.801 16.1837 66.5452 17.8144 67.6269L44.6842 83.3218C46.232 84.2261 48.7652 84.2261 50.313 83.3218L77.1828 67.6269C78.9325 66.4495 79.9284 64.6774 79.9972 62.695V31.305C79.9343 29.4023 78.8081 27.4832 77.1828 26.3731ZM25.8329 47.0001C25.7056 25.5966 54.0413 16.1457 66.2609 36.0334L56.8845 41.5228C51.2243 32.0511 37.1701 35.4378 36.6657 47.0001C36.8172 57.6563 50.6305 62.6063 56.8852 52.4768L66.2615 57.9659C55.4925 76.8797 26.376 70.0749 25.8329 47.0001ZM69.1643 48.2177H66.7569V50.6534H64.3499V48.2177H61.9424V45.7823H64.3499V43.3468H66.7569V45.7823H69.1643V48.2177ZM78.1917 48.2177H75.7843V50.6534H73.3773V48.2177H70.9698V45.7823H73.3773V43.3468H75.7843V45.7823H78.1917V48.2177Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c++.103f98e9dce4c0eaeb8d4167e6c00184.svg";
export { ForwardRef as ReactComponent };